import React from "react";
import { useGetSequenceStatsQuery } from "@/store/rest_api";
import { Card, CardContent } from "@/components/ui/card";

const FUNNEL_LABELS: Record<string, string> = {
  ENROLLED: "Enrolled",
  AWAITING_CONSENT: "Awaiting consent",
  CONTACTED: "Contacted",
  REPLIED: "Replied",
  CONVERTED: "Converted",
  SUPPRESSED: "Suppressed",
  DONE: "Done",
};

const FUNNEL_ORDER = ["ENROLLED", "AWAITING_CONSENT", "CONTACTED", "REPLIED", "CONVERTED", "SUPPRESSED", "DONE"];

export default function SequenceStatsHeader({ campaignId }: { campaignId: string }) {
  const { data: stats } = useGetSequenceStatsQuery(campaignId, { pollingInterval: 30_000 });

  if (!stats) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3">
        {FUNNEL_ORDER.map((status) => (
          <Card key={status}>
            <CardContent className="p-4">
              <p className="text-2xl font-bold">{stats.funnel[status] ?? 0}</p>
              <p className="text-xs text-muted-foreground">{FUNNEL_LABELS[status]}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {stats.steps.length > 0 && (
        <Card>
          <CardContent className="p-4">
            <p className="mb-3 text-sm font-medium">Steps</p>
            <div className="space-y-2">
              {stats.steps.map((step, index) => {
                const completed = step.counts["COMPLETED"] ?? 0;
                const failed = step.counts["FAILED"] ?? 0;
                const pending =
                  (step.counts["PENDING"] ?? 0) + (step.counts["RUNNING"] ?? 0) + (step.counts["WAITING"] ?? 0);
                return (
                  <div key={step.actionId ?? index} className="flex items-center justify-between text-sm">
                    <span className="text-muted-foreground">
                      {index + 1}. {step.actionType.replace(/_/g, " ")}
                    </span>
                    <span>
                      <span className="font-medium">{completed}</span> sent
                      {failed > 0 && <span className="text-destructive"> · {failed} failed</span>}
                      {pending > 0 && <span className="text-muted-foreground"> · {pending} pending</span>}
                    </span>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
